import { Alert } from '@synoptic/ui-kit/alert/alert.js';
import { LevelEmptyIcon } from '@synoptic/ui-kit/icons/react/level-empty.js';
import { LevelHighIcon } from '@synoptic/ui-kit/icons/react/level-high.js';
import { LevelLowIcon } from '@synoptic/ui-kit/icons/react/level-low.js';
import { LevelMidIcon } from '@synoptic/ui-kit/icons/react/level-mid.js';
import clsx from 'clsx';
import {
  AiFilterEvaluation,
  AiFilterQualityLevel,
} from '@/__generated__/schema-types';
import {
  filterQualityAlertIcon,
  filterQualityAlertIconVariant,
  filterQualityAlertVariant,
} from './manage-filter.css';

const qualityLevelIcon = {
  [AiFilterQualityLevel.High]: (
    <LevelHighIcon
      className={clsx(
        filterQualityAlertIcon,
        filterQualityAlertIconVariant.high,
      )}
    />
  ),
  [AiFilterQualityLevel.Medium]: (
    <LevelMidIcon
      className={clsx(
        filterQualityAlertIcon,
        filterQualityAlertIconVariant.medium,
      )}
    />
  ),
  [AiFilterQualityLevel.Low]: (
    <LevelLowIcon
      className={clsx(
        filterQualityAlertIcon,
        filterQualityAlertIconVariant.low,
      )}
    />
  ),
  unknown: (
    <LevelEmptyIcon
      className={clsx(
        filterQualityAlertIcon,
        filterQualityAlertIconVariant.unknown,
      )}
    />
  ),
};

export const FilterQualityAlert = ({
  aiFilterEvaluation,
  isLoading,
  error,
}: {
  aiFilterEvaluation: AiFilterEvaluation | null;
  isLoading: boolean;
  error: Error | null;
}) => {
  const qualityLevel = aiFilterEvaluation?.qualityLevel ?? 'unknown';

  if (error) {
    return (
      <Alert
        icon={qualityLevelIcon.unknown}
        className={filterQualityAlertVariant.error}
      >
        Error while evaluating filter. Please try again.
      </Alert>
    );
  }

  if (isLoading) {
    return <Alert icon={qualityLevelIcon.unknown}>Evaluating filter</Alert>;
  }

  return (
    <Alert
      icon={qualityLevelIcon[qualityLevel]}
      className={clsx(
        qualityLevel !== 'unknown' && filterQualityAlertVariant[qualityLevel],
      )}
    >
      {aiFilterEvaluation?.comment ??
        'Fill out the form above to view the filter’s feedback.'}
    </Alert>
  );
};
